import { filterMenuProps } from "../types/tag";
// Tag categories with all the options
export const getTags = (t: any): filterMenuProps[] => [
	{
		title: t("filter.occasions.title"),
		slug: "prilezitosti",
		tags: [
			{ slug: "snidane", text: t("filter.occasions.snidane") },
			{ slug: "brunch", text: t("filter.occasions.brunch") },
			{ slug: "dopoledni_coffee_break", text: t("filter.occasions.dopoledni_coffee_break") },
			{ slug: "obed", text: t("filter.occasions.obed") },
			{ slug: "odpoledni_coffee_break", text: t("filter.occasions.odpoledni_coffee_break") },
			{ slug: "vecere", text: t("filter.occasions.vecere") },
			{ slug: "welcome_drink", text: t("filter.occasions.welcome_drink") },
			{ slug: "afterparty", text: t("filter.occasions.afterparty") },
			{ slug: "grilovani", text: t("filter.occasions.grilovani") }
		]
	},
	{
		title: t("filter.diets.title"),
		slug: "diety",
		tags: [
			{ slug: "vegetarianska", text: t("filter.diets.vegetarianska") },
			{ slug: "veganska", text: t("filter.diets.veganska") },
			{ slug: "bezlepkova", text: t("filter.diets.bezlepkova") },
			{ slug: "bezlaktozova", text: t("filter.diets.bezlaktozova") },
			{ slug: "diabeticka_dieta", text: t("filter.diets.diabeticka_dieta") },
			{ slug: "paleo", text: t("filter.diets.paleo") },
			{ slug: "keto", text: t("filter.diets.keto") },
			{ slug: "pescetarianska", text: t("filter.diets.pescetarianska") },
			{ slug: "nizkosacharidova", text: t("filter.diets.nizkosacharidova") },
			{ slug: "dieta_se_snizenym_obsahem_soli", text: t("filter.diets.dieta_se_snizenym_obsahem_soli") },
			{ slug: "koser", text: t("filter.diets.koser") },
			{ slug: "raw", text: t("filter.diets.raw") }
		]
	},
	{
		title: t("filter.food_types.title"),
		slug: "typy_jidla",
		tags: [
			{ slug: "polevky", text: t("filter.food_types.polevky") },
			{ slug: "hlavni_jidla", text: t("filter.food_types.hlavni_jidla") },
			{ slug: "dezerty", text: t("filter.food_types.dezerty") },
			{ slug: "predkrmy", text: t("filter.food_types.predkrmy") },
			{ slug: "salaty", text: t("filter.food_types.salaty") },
			{ slug: "prilohy", text: t("filter.food_types.prilohy") },
			{ slug: "pecivo", text: t("filter.food_types.pecivo") },
			{ slug: "oblozene_misy", text: t("filter.food_types.oblozene_misy") },
			{ slug: "napoje", text: t("filter.food_types.napoje") },
			{ slug: "finger_food", text: t("filter.food_types.finger_food") },
			{ slug: "chutovky", text: t("filter.food_types.chutovky") },
			{ slug: "alkoholicke_napoje", text: t("filter.food_types.alkoholicke_napoje") },
			{ slug: "nealkoholicke_napoje", text: t("filter.food_types.nealkoholicke_napoje") },
			{ slug: "storage", text: t("filter.food_types.storage") }
		]
	},
	{
		title: t("filter.cuisines.title"),
		slug: "druh_kuchyne",
		tags: [
			{ slug: "ceska", text: t("filter.cuisines.ceska") },
			{ slug: "italska", text: t("filter.cuisines.italska") },
			{ slug: "asijska", text: t("filter.cuisines.asijska") },
			{ slug: "stredomorska", text: t("filter.cuisines.stredomorska") },
			{ slug: "indicka", text: t("filter.cuisines.indicka") },
			{ slug: "francouzska", text: t("filter.cuisines.francouzska") },
			{ slug: "mexicka", text: t("filter.cuisines.mexicka") },
			{ slug: "mezinarodni", text: t("filter.cuisines.mezinarodni") },
			{ slug: "cinska", text: t("filter.cuisines.cinska") },
			{ slug: "thajska", text: t("filter.cuisines.thajska") },
			{ slug: "vietnamska", text: t("filter.cuisines.vietnamska") }
		]
	},
	{
		title: t("filter.temperature.title"),
		slug: "teplota_pokrmu",
		tags: [
			{ slug: "teple", text: t("filter.temperature.teple") },
			{ slug: "studene", text: t("filter.temperature.studene") }
		]
	},
	{
		title: t("filter.serving.title"),
		slug: "forma_podani",
		tags: [
			{ slug: "krabicky_individualni_porce", text: t("filter.serving.krabicky_individualni_porce") },
			{ slug: "bufet", text: t("filter.serving.bufet") },
			{ slug: "raut", text: t("filter.serving.raut") },
			{ slug: "mealbox", text: t("filter.serving.mealbox") },
			{ slug: "degustacni_porce", text: t("filter.serving.degustacni_porce") },
			{ slug: "svedsky_stul", text: t("filter.serving.svedsky_stul") },
			{ slug: "servirovane_menu", text: t("filter.serving.servirovane_menu") }
		]
	},
	{
		title: t("filter.labels.title"),
		slug: "specialni_oznaceni",
		tags: [
			{ slug: "sezonni_nabidka", text: t("filter.labels.sezonni_nabidka") },
			{ slug: "novinka", text: t("filter.labels.novinka") },
			{ slug: "doporučujeme", text: t("filter.labels.doporučujeme") }
		]
	},
	{
		title: t("filter.for_what.title"),
		slug: "pro_co",
		tags: [
			{ slug: "konference", text: t("filter.for_what.konference") },
			{ slug: "firemni_vecirek", text: t("filter.for_what.firemni_vecirek") },
			{ slug: "obchodni_jednani", text: t("filter.for_what.obchodni_jednani") },
			{ slug: "oslava", text: t("filter.for_what.oslava") },
			{ slug: "garden_party", text: t("filter.for_what.garden_party") },
			{ slug: "networking", text: t("filter.for_what.networking") },
			{ slug: "seminar", text: t("filter.for_what.seminar") },
			{ slug: "vanocni_vecirek", text: t("filter.for_what.vanocni_vecirek") },
			{ slug: "prezentace", text: t("filter.for_what.prezentace") },
			{ slug: "teambuilding", text: t("filter.for_what.teambuilding") },
			{ slug: "narozeniny", text: t("filter.for_what.narozeniny") },
			{ slug: "vernisaz", text: t("filter.for_what.vernisaz") },
			{ slug: "beneficni_akce", text: t("filter.for_what.beneficni_akce") },
			{ slug: "charitativni_vecer", text: t("filter.for_what.charitativni_vecer") },
			{ slug: "rodinna_setkani", text: t("filter.for_what.rodinna_setkani") },
			{ slug: "porady", text: t("filter.for_what.porady") },
			{ slug: "skoleni_externi", text: t("filter.for_what.skoleni_externi") },
			{ slug: "kulturni_akce", text: t("filter.for_what.kulturni_akce") },
			{ slug: "spolecne_sledovani_sportu", text: t("filter.for_what.spolecne_sledovani_sportu") },
			{ slug: "interni_skoleni", text: t("filter.for_what.interni_skoleni") },
			{ slug: "management_meeting", text: t("filter.for_what.management_meeting") },
			{ slug: "svatba", text: t("filter.for_what.svatba") },
			{ slug: "neformalni_setkani", text: t("filter.for_what.neformalni_setkani") }
		]
	},
	{
		title: t("filter.for_whom.title"),
		slug: "pro_koho",
		tags: [
			{ slug: "deti", text: t("filter.for_whom.deti") },
			{ slug: "studenti", text: t("filter.for_whom.studenti") },
			{ slug: "zamestnanci_zakladni_pozice", text: t("filter.for_whom.zamestnanci_zakladni_pozice") },
			{ slug: "stredni_management", text: t("filter.for_whom.stredni_management") },
			{ slug: "vrcholovy_management", text: t("filter.for_whom.vrcholovy_management") },
			{ slug: "vip", text: t("filter.for_whom.vip") },
			{ slug: "tuzemsti_hoste", text: t("filter.for_whom.tuzemsti_hoste") },
			{ slug: "zahranicni_hoste", text: t("filter.for_whom.zahranicni_hoste") },
			{ slug: "diplomate", text: t("filter.for_whom.diplomate") },
			{ slug: "seniori", text: t("filter.for_whom.seniori") }
		]
	}
];
